<template>
  <div class="contact" id="contact">
    <my-header />

    <div class="contactMenu clear">
      <div class="contactLeft left">
        <p class="p1">联系</p>
        <p class="p2"><router-link to="/findDealer">寻找经销商</router-link></p>
        <p class="p2"><router-link to="/contact">联系我们</router-link></p>
      </div>
      <div class="contactRight left">
        <div class="pre">
          <div class="allTitle">
            <span>联系我们</span>
          </div>
        </div>

        <div class="pre" v-for="(current, i) in dataList">
          <div class="contactMain" v-html="current.content"></div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->

    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      dataList: []
    };
  },
  mounted() {
    if (this.$route.query.go) {
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }

    let that = this;
    that.$axios
      .get(that.$global.baseURL + "/web/modules/getModulesByCatalogId.form", {
        params: {
          catalogId: "5"
        }
      })
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.dataList = res.data.dataList;
        }
      });
  }
};
</script>

<style>
/*最外层 */
.pre {
  width: 90%;
}

.contact .pre .allTitle {
  width: 80%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  letter-spacing: 10px;
  font-weight: lighter;
  font-family: "microsoft yahei";
  padding-top: 50px;
  padding-bottom: 20px;
}

.contactMenu .contactLeft {
  width: 100px;
  margin-left: 80px;
  margin-top: 65px;
  letter-spacing: 2px;
}

.contactMenu .contactLeft .p1 {
  font-size: 18px;
  margin-bottom: 30px;
}

.contactMenu .contactLeft .p2 {
  font-size: 14px;
}

.contactMenu .contactLeft p {
  margin-top: -10px;
  color: #595757;
}

.contactMenu .contactLeft a {
  text-decoration: none;
  color: #595757;
}

.contactMenu .contactLeft a:hover {
  text-decoration: none;
  color: #ccb356;
}

/* 	.contactMenu .contactLeft a:active{
		text-decoration: none;
		color: #CCB356;
	} */

.contactMenu .contactRight {
  width: -moz-calc(100% - 217px);
  width: -webkit-calc(100% - 217px);
  width: calc(100% - 217px);
}

.contactMain {
  width: 75%;
  color: #595757;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 100px;
  letter-spacing: 2px;
}

.contactMain p {
  /* margin-left: 5%; */
  line-height: 35px;
  margin-top: 30px;
  font-size: 16px;
  color: #595757;
}

.contactMain .p1 span {
  font-size: 25px;
}

.contactMain .p2 {
  font-size: 30px;
  margin-top: 60px;
}

.contactMain .p3 span {
  margin-left: 30px;
}

.contactMain img {
  width: 100%;
}

/* 媒体查询 */
@media screen and (max-width: 850px) {
  .contactMenu .contactLeft {
    display: none;
  }

  .contactMenu .contactRight {
    width: 100%;
  }

  .contactMenu .contactRight .pre {
    width: 100%;
    margin: 0 auto;
  }

  .contactMenu .contactRight .allTitle {
    width: 90%;
    margin-left: 30px;
    text-align: center;
    margin: 0 auto;
  }

  .contactMenu .contactRight .contactMain {
    width: 90%;
    margin: 0 auto;
    margin-left: 26px;
    text-align: center;
  }

  .contactMain .p3 {
    text-align: center;
  }

  .contactMain .p3 span {
    width: 100%;
    margin: 0 auto;
    float: left;
    display: block;
  }

  /* .contactMenu .contactRight .contactMain .contentTime {
			font-size: 15px;
			color: #595757;
			margin-top: 20px;
		} */
}
</style>
